import { FileValidationRule } from './file-validation-rule';

export class FilenameValidationRule implements FileValidationRule {
    public readonly errorKey = 'invalidCharacters';

    public validate(file: File): boolean {
        const filenameWithoutTyp = file.name.split('.').slice(0, -1).join('.');

        if (filenameWithoutTyp.length == 0) {
            return false;
        }

        // check com1, com2 bis com9 und lpt1, lpt2 bis lpt9
        if (filenameWithoutTyp.length == 4) {
            const reservedPattern = /(com[1-9]|lpt[1-9])/i;
            if (reservedPattern.exec(filenameWithoutTyp)) {
                return false;
            }

        }

        // check das nicht con, prn, aux, nul der Dateiname ist
        if (filenameWithoutTyp.length == 3) {
            const reservedPattern = /(con|prn|aux|nul)/i;
            if (reservedPattern.exec(filenameWithoutTyp)) {
                return false;
            }

        }

        // check start und ende . oder Leerzeichen
        return !(filenameWithoutTyp.startsWith('.')
            || filenameWithoutTyp.endsWith('.')
            || filenameWithoutTyp.startsWith(' ')
            || filenameWithoutTyp.endsWith(' '));
    }

}